<div class="mat-form-field upload-photo">
  <div class="file-upload" *ngIf="!apiFilePath.value">
    <label for="doc">{{label? label : 'Upload ' + type | titlecase}}</label>
    <input type="file" [accept]="accept" [disabled]="!isEditable" [formControl]="fileControl"
      (change)="onSelectedFile($event)" />
  </div>
  <div class="hint pl-2 p-1" *ngIf="hint">{{hint}}</div>
  <div class="downlaodlnk form-control" *ngIf="apiFilePath.value">
    <a [href]="apiFilePath.value" target="_blank">
      <i class="fa fa-download"></i>
      View/Download File</a>
    <button (click)="removeFile()" class="btn btn-danger" matTooltip="Remove this File" *ngIf="isEditable"
      matTooltipPosition="below" style="padding: 7px;">
      <mat-icon style="transform: scale(0.7)">close</mat-icon>
    </button>
  </div>
</div>
